import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { S3_PUBLIC_PATH } from "../../../config/constants";
import useStyles, { InputField } from "./styled";

const GateAgent = (props) => {
  const { eventDetail, queryCode, onEnterCode } = props;
  const [code1, setCode1] = useState("");
  const [code2, setCode2] = useState("");
  const [code3, setCode3] = useState("");
  // const [code, setCode] = useState("");
  useEffect(() => {
    if (queryCode) {
      const codeTMP = queryCode.split("-").join("");
      setCode1(codeTMP.substring(0, 3));
      setCode2(codeTMP.substring(3, 6));
      setCode3(codeTMP.substring(6, 9));
      // setCode(queryCode);
    }
  }, []);
  const onChangeInput = (index, text) => {
    // Change input box three input to on input not interested tick

    if (index === "code1") {
      setCode1(text.toUpperCase().substring(0, 3));
      if (text.length >= 3) {
        code2Input.current.focus();
      }
    }
    if (index === "code2") {
      setCode2(text.toUpperCase().substring(0, 3));
      if (text.length >= 3) {
        code3Input.current.focus();
      }
    }
    if (index === "code3") {
      setCode3(text.toUpperCase().substring(0, 3));
      if (text.length >= 3) {
        code1Input.current.focus();
      }
    }
    // setCode(text);
  };
  const code1Input = React.createRef();
  const code2Input = React.createRef();
  const code3Input = React.createRef();
  const canSubmit =
    code1.length === 3 && code2.length === 3 && code3.length === 3;
  const onSubmit = () => {
    onEnterCode(code1 + code2 + code3);
  };
  // const eventImg = eventDetail.image_1
  const eventImg = S3_PUBLIC_PATH + 'ylp-poster.png?format=basic&resize=w425,h610'

  const classes = useStyles({ eventStyles: eventDetail.style });
  return (
    <Paper elevation={0} className={classes.paper}>
      <Grid container spacing={2} disableGutters alignItems="center">
        <Grid item xs={12} sm={12} md={5}>
          <img src={eventImg} className={classes.img} />
        </Grid>
        <Grid item xs={12} sm={12} md={7}>
          <div className={classes.content}>
            <div className={classes.text}>
            {eventDetail.text_1 || "Enter your 9-digit code to access the live event."}
              <br />
              {eventDetail.text_2 || "Your Entrant Code is the 9-digit code found on your E-Ticket."}
            </div>
            <div className={classes.sectionInputCode}>
              <Grid container spacing={2} disableGutters justify="center">
                <Grid item>
                  <InputField
                    autoFocus
                    value={code1}
                    onChange={(event) => {
                      onChangeInput('code1', event.target.value);
                    }}
                    inputRef={code1Input}
                  />
                </Grid>
                <Grid item>
                  <InputField
                    value={code2}
                    onChange={event => {
                      onChangeInput('code2', event.target.value)
                    }}
                    inputRef={code2Input}
                  />
                </Grid>
                <Grid item>
                  <InputField
                    value={code3}
                    onChange={event => {
                      onChangeInput('code3', event.target.value)
                    }}
                    inputRef={code3Input}
                  />
                </Grid>
              </Grid>
            </div>
            <div className={classes.sectionButton}>
              <Grid container justifyContent="center">
                <Grid item md={5}>
                  <Button
                    className={classes.button}
                    onClick={onSubmit}
                    fullWidth
                  >
                    Log in
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default GateAgent;
